import { ETC } from '../types';
export default {
  type: ETC,
  service: 'CW Parity',
  url: 'https://etc-parity.0xinfra.com/',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
